import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import { useTitleSearch } from '../../hooks/use-title-search'
import { useSeriesSearch } from '../../hooks/use-series-search'
import { useRentalSearch } from '../../hooks/use-rental-search'
import { useGetSearchConfig } from '../../hooks/use-get-search-config'
import NoResults from './no-results'
import Searching from './searching'
import Fade from '../../../../components/transitions/fade'
import { useStyles } from './paged-searc-result.styles'
import SearchCarouselWithType from '../search-carousel/search-carousel-with-type'
import { useMyList } from '../../../../hooks/use-my-list'
import { segmentTrackSearchResult, segmentTrackSearchNoResult } from '../../../../segment/segment-track'

/**
 * Component to display all three carousels for search result
 */
export const PagedSearchResult = () => {
  const { minChar } = useGetSearchConfig()

  const {
    seriesTiles,
    isLoadingSeries,
    fetchMoreSeries,
    seriesCount
  } = useSeriesSearch()

  const {
    titleTiles,
    isLoadingTitles,
    fetchMoreTitles,
    titleCount
  } = useTitleSearch()

  const {
    rentalsTiles,
    isLoadingRentals,
    fetchMoreRentals,
    rentalsCount
  } = useRentalSearch()

  useEffect(() => {
    document.body.classList.add('noScroll')
    return () => {
      document.body.classList.remove('noScroll')
    }
  }, [])

  const isLoading = isLoadingSeries || isLoadingTitles || isLoadingRentals

  const totalItems =
    seriesTiles.length + titleTiles.length + rentalsTiles.length

  const location = useLocation()
  const { search: searchQuery } = qs.parse(location.search)

  const styles = useStyles()

  const { allItems, addToMyList } = useMyList()

  useEffect(() => {
    // Add segment data analytics for searching
    const totalCount = seriesCount + titleCount + rentalsCount
    if (!isLoading) {
      if (totalCount === 0 && searchQuery >= minChar) {
        segmentTrackSearchNoResult({
          searchItem: searchQuery
        })
      } else if (totalCount > 0) {
        segmentTrackSearchResult({
          searchItem: searchQuery,
          totalResults: totalCount
        })
      }
    }
  }, [seriesCount, titleCount, rentalsCount])

  return (
    <Fade
      in
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.wrapper}>
        <div className={styles.searchTitle}>
          Results for
          {' '}
          <span className={styles.searchQuery}>
            &apos;
            {searchQuery}
            &apos;
          </span>
        </div>
        <Fade in={Boolean(isLoading)} mountOnEnter unmountOnExit>
          <Searching />
        </Fade>
        <Fade
          in={Boolean(
            !isLoadingSeries &&
              !isLoadingTitles &&
              !isLoadingRentals &&
              totalItems === 0
          )}
          mountOnEnter
          unmountOnExit
        >
          <NoResults query={searchQuery} />
        </Fade>
        <Fade
          in={Boolean(!isLoading && searchQuery)}
          mountOnEnter
          unmountOnExit
        >
          <SearchCarouselWithType
            tiles={seriesTiles}
            carouselName="Series"
            tilesCount={seriesCount}
            onClickFetchMore={fetchMoreSeries}
            type="SERIES"
            myListItems={allItems}
            addToMyList={addToMyList}
          />
          <SearchCarouselWithType
            tiles={titleTiles}
            carouselName="Movies"
            tilesCount={titleCount}
            onClickFetchMore={fetchMoreTitles}
            type="TITLE"
            myListItems={allItems}
            addToMyList={addToMyList}
          />
          <SearchCarouselWithType
            tiles={rentalsTiles}
            carouselName="Rentals"
            tilesCount={rentalsCount}
            onClickFetchMore={fetchMoreRentals}
            type="RENTAL"
            myListItems={allItems}
            addToMyList={addToMyList}
          />
        </Fade>
      </div>
    </Fade>
  )
}
